<template>
  <div class="trusts">
    <div class="row justify-content-center">
      <div class="col-4">
        <div class="trust">
          <i class="icon"><icon-fa-home-lg /></i>
          <div class="text">
            <p class="h4">
              {{ $t('common:trusts.passion') }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="trust">
          <i class="icon"><icon-fa-thumbs-up /></i>
          <div class="text">
            <p class="h4">
              {{ $t('common:trusts.knowledge') }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="trust">
          <i class="icon"><icon-fa-shield-alt /></i>
          <div class="text">
            <p class="h4">
              {{ $t('common:trusts.service') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* ICONS */
import IconFaHomeLg from 'icons/fa/light/home-lg.svg';
import IconFaThumbsUp from 'icons/fa/light/thumbs-up.svg';
import IconFaShieldAlt from 'icons/fa/light/shield-alt.svg';

export default {
  components: {
    IconFaHomeLg,
    IconFaThumbsUp,
    IconFaShieldAlt,
  },
};
</script>
<style lang="scss" scoped>
  .trusts {
    overflow: hidden;
    padding: 1em $margin_content;
    background: rgba($color_grey_500, 1);

    width: 100%;
    z-index: 100;
    color: #fff;

    @include text_shadow;

    @media #{$media_sm_max} {
      display: none;
    }
  }

  .trust {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    text-align: left;

    .icon,
    .img {
      font-size: 2em;
      margin: 0 $margin_content_xs 0 0;
      line-height: 1em;
      display: block;
      // overflow: hidden;
      width: 1em;

      img,
      svg {
        display: block;
        height: 1em;
        margin: 0 auto;
        width: auto;
        padding: 0;
      }
    }

    .text {
      @include font_regular;

      line-height: 1.3em;
      display: inline-block;


      h3,
      .h4,
      h4,
      h5 {
        color: #fff;
        @include font_size_l;
        @include font_bold;
        margin: .25em 0 0 0.25em;
        display: block;
        @media #{$media_lg_max} {
          font-size: 1em;
        }
      }

      p {
        display: inline;
        cursor: text;
        margin: 0.25em 0 0;
        @media #{$media_lg_max} {
          @include font_size_s;
        }
      }
    }
  }
</style>
